import { useState } from 'react';
import { IPhoto } from 'pages/SchedulerList/components/Inspection/Inspection.types';
import { useBase64Converter } from './useBase64Converter';
import PhotoService from 'services/PhotoService/photoService';

interface IUsePhotoEditorProps {
  getCurrentPhoto: () => IPhoto | undefined;
}

export const usePhotoEditor = ({ getCurrentPhoto }: IUsePhotoEditorProps) => {
  const [currentImage, setCurrentImage] = useState<string>('');
  const [showEditor, setShowEditor] = useState(false);
  const [loading, setLoading] = useState(false);

  const { arrayBufferToBase64 } = useBase64Converter();

  const openEditor = async () => {
    const photo = getCurrentPhoto();
    if (!photo) return;

    try {
      const data = await PhotoService.getArrayBuffer(photo);
      const base64Data = await arrayBufferToBase64(data);

      if (base64Data) {
        const base64 = `data:image/jpeg;base64,${base64Data}`;
        setCurrentImage(base64);
        setShowEditor(true);
      }
    } catch (error) {
      console.error('Erro ao abrir editor:', error);
      throw error;
    }
  };

  const closeEditor = () => {
    setShowEditor(false);
    setCurrentImage('');
  };

  const setIsLoading = (isLoading: boolean) => {
    setLoading(isLoading);
  };

  return {
    currentImage,
    showEditor,
    loading,
    openEditor,
    closeEditor,
    setIsLoading,
  };
};
